/*
  assets/gtender-share-receiver.js — GTENDER-SHARE-RECEIVER-G21-02
  Owner: additive receiver affordances for GTender ?tender= deep links.
  Boundary: does not fetch tender data and does not own detail, search, bookmark, auth, or official-source state.
*/
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-gtender-public-entry]';
  var DETAIL_SELECTOR = '[data-gtender-public-detail]';
  var DETAIL_SHELL_SELECTOR = '.gtender-public-detail__shell';
  var TENDER_ID_RE = /^[A-Za-z0-9._:-]{3,240}$/;
  var VERSION = '2026-10-05-share-receiver-g21-02';

  function clean(value) {
    return String(value == null ? '' : value)
      .replace(/\s+/g, ' ')
      .trim();
  }

  function sharedTenderId() {
    try {
      var id = clean(new URL(window.location.href).searchParams.get('tender'));
      return TENDER_ID_RE.test(id) ? id : '';
    } catch (_error) {
      return '';
    }
  }

  function isZh(root) {
    var raw =
      clean(root && root.getAttribute('data-locale')) ||
      clean(document.documentElement && document.documentElement.lang) ||
      'en';
    return /^zh/i.test(raw);
  }

  function copy(root) {
    return isZh(root)
      ? {
          browse: '查看其他招標',
          unavailable: '這個分享連結的招標目前無法顯示，可能已下架或資料暫時不可用。',
          closed: '這個招標已截止。你仍可查看現有資料，或瀏覽最新招標。',
        }
      : {
          browse: 'Browse other tenders',
          unavailable:
            'This shared tender is currently unavailable. It may have been removed or the data may be temporarily unavailable.',
          closed:
            'This tender has closed. You can still review the available details or browse the latest tenders.',
        };
  }

  function ensureStyles() {
    if (document.getElementById('gtender-share-receiver-styles')) return;
    var style = document.createElement('style');
    style.id = 'gtender-share-receiver-styles';
    style.textContent = [
      '.gtender-share-receiver{margin:16px 0 0;padding:14px;border-radius:16px;background:rgba(118,118,128,.08);font-family:-apple-system,BlinkMacSystemFont,"SF Pro Text","Helvetica Neue",Arial,sans-serif;}',
      '.gtender-share-receiver__notice{margin:0 0 10px;color:#3a3a3c;font-size:14px;line-height:1.45;}',
      '.gtender-share-receiver__notice:empty{display:none;}',
      '.gtender-share-receiver__browse{display:flex;align-items:center;justify-content:center;width:100%;min-height:44px;padding:0 16px;border:0;border-radius:12px;background:#007aff;color:#fff;font:inherit;font-size:15px;font-weight:650;cursor:pointer;}',
      '.gtender-share-receiver__browse:focus-visible{outline:3px solid rgba(0,122,255,.32);outline-offset:2px;}',
      '@media (prefers-color-scheme:dark){.gtender-share-receiver{background:rgba(118,118,128,.18)}.gtender-share-receiver__notice{color:#ebebf5}}',
      '@media (prefers-reduced-motion:reduce){.gtender-share-receiver__browse{scroll-behavior:auto}}',
    ].join('');
    document.head.appendChild(style);
  }

  function removeTenderParam() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('tender');
      window.history.replaceState(
        window.history.state,
        '',
        url.pathname + (url.search ? url.search : '') + (url.hash ? url.hash : '')
      );
    } catch (_error) {}
  }

  function focusFeed(root) {
    var target =
      root.querySelector('[data-gtender-search-query]') || root.querySelector('form') || root;
    try {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (_error) {
      target.scrollIntoView();
    }
    if (typeof target.focus === 'function') {
      if (!target.hasAttribute('tabindex') && target === root)
        target.setAttribute('tabindex', '-1');
      try {
        target.focus({ preventScroll: true });
      } catch (_error) {
        target.focus();
      }
    }
  }

  function browseLatest(root, detail) {
    removeTenderParam();
    var close = detail.querySelector('[data-gtender-detail-close]');
    if (close) close.click();
    window.setTimeout(function () {
      focusFeed(root);
    }, 0);
  }

  function ensurePanel(root, detail) {
    var existing = detail.querySelector('[data-gtender-share-receiver-panel]');
    if (existing) return existing;

    ensureStyles();
    var strings = copy(root);
    var panel = document.createElement('section');
    panel.className = 'gtender-share-receiver';
    panel.setAttribute('data-gtender-share-receiver-panel', '');

    var notice = document.createElement('p');
    notice.className = 'gtender-share-receiver__notice';
    notice.setAttribute('data-gtender-share-receiver-notice', '');
    notice.setAttribute('aria-live', 'polite');

    var browse = document.createElement('button');
    browse.type = 'button';
    browse.className = 'gtender-share-receiver__browse';
    browse.setAttribute('data-gtender-share-receiver-browse', '');
    browse.textContent = strings.browse;
    browse.addEventListener('click', function () {
      browseLatest(root, detail);
    });

    panel.appendChild(notice);
    panel.appendChild(browse);

    var shell = detail.querySelector(DETAIL_SHELL_SELECTOR);
    (shell || detail).appendChild(panel);
    return panel;
  }

  function statusKind(detail) {
    var status = clean(
      detail.querySelector('[data-gtender-detail-status]') &&
        detail.querySelector('[data-gtender-detail-status]').textContent
    );
    var state = clean(
      detail.querySelector('[data-gtender-detail-state]') &&
        detail.querySelector('[data-gtender-detail-state]').textContent
    );
    if (/expired|closed|ended|cancelled|canceled|已截止|已結束|已结束|取消/i.test(state))
      return 'closed';
    if (/unavailable|could not|暫時無法|暂时无法|not available|not found/i.test(status))
      return 'unavailable';
    return '';
  }

  function sync(root, detail, panel) {
    var notice = panel.querySelector('[data-gtender-share-receiver-notice]');
    if (!notice) return;
    var strings = copy(root);
    var kind = statusKind(detail);
    const nextNotice =
      kind === 'closed' ? strings.closed : kind === 'unavailable' ? strings.unavailable : '';
    const nextState = kind || 'available';

    if (notice.textContent !== nextNotice) {
      notice.textContent = nextNotice;
    }
    if (panel.getAttribute('data-receiver-state') !== nextState) {
      panel.setAttribute('data-receiver-state', nextState);
    }
  }

  function mount(root) {
    if (!root || !sharedTenderId()) return;
    root.setAttribute('data-gtender-share-receiver', 'true');

    var attach = function () {
      var detail = root.querySelector(DETAIL_SELECTOR);
      if (!detail) return false;
      var panel = ensurePanel(root, detail);
      sync(root, detail, panel);
      if (detail.getAttribute('data-gtender-share-receiver-observed') !== 'true') {
        detail.setAttribute('data-gtender-share-receiver-observed', 'true');
        new MutationObserver(function () {
          sync(root, detail, panel);
        }).observe(detail, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['data-status-tone'],
        });
      }
      return true;
    };

    if (attach()) return;
    var observer = new MutationObserver(function () {
      if (attach()) observer.disconnect();
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function boot() {
    if (!sharedTenderId()) return;
    var root = document.querySelector(ROOT_SELECTOR);
    if (root) mount(root);
    else {
      var observer = new MutationObserver(function () {
        root = document.querySelector(ROOT_SELECTOR);
        if (!(root instanceof HTMLElement)) return;
        observer.disconnect();
        mount(root);
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  window.GTenderShareReceiver = Object.freeze({ version: VERSION });
})();
